import { h } from 'preact';
export const BarChart = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "12", y1: "20", x2: "12", y2: "10" }),
        h("line", { x1: "18", y1: "20", x2: "18", y2: "4" }),
        h("line", { x1: "6", y1: "20", x2: "6", y2: "16" })));
};
//# sourceMappingURL=bar-chart.js.map